import { CURRENCY_ISO_TO_SYMBOL } from '../../constants';
import BoxedText from '../BoxedText';

const CurrencyWithSymbol = ({ className, isoCode }: { className?: string; isoCode: string }) => {
  const symbol = CURRENCY_ISO_TO_SYMBOL[isoCode];
  return <BoxedText isOneLine className={className}>{`${symbol ?? ''}${isoCode}`}</BoxedText>;
};

export default CurrencyWithSymbol;
